import React, { FC } from 'react';
import { DraggableComponentProps } from 'features/document/constants';
import { Box } from '@mui/material';
import { isSignatureElement } from 'utils/typeGuards';

const Signature: FC<DraggableComponentProps> = ({ currentElement }) => {
  if (!isSignatureElement(currentElement)) {
    return null;
  }
  const { labelText } = currentElement.content;
  const { justifyContent } = currentElement.style;

  return (
    <Box alignItems={'center'} display={'flex'} height={'50px'} justifyContent={justifyContent} padding={'12px 16px'}>
      <span>{labelText}</span>
    </Box>
  );
};

export default Signature;
